package com.eladfinish.bible.contest.screens.browse.contentOfChapter.ui

import androidx.compose.foundation.ScrollState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberUpdatedState

@Composable
internal fun BindGoToMarkerController(
    isActivePage: Boolean,
    scrollState: ScrollState,
    rawText: String,
    controller: GoToMarkerController,
) {
    val latestText = rememberUpdatedState(rawText)

    LaunchedEffect(isActivePage, scrollState, controller) {
        if (isActivePage) controller.scrollState = scrollState
    }

    LaunchedEffect(isActivePage, latestText.value, controller) {
        if (isActivePage) controller.rawText = latestText.value
    }
}
